import { useAuth } from 'contexts/auth';
import { useEffect } from 'react';

const useElapsedTime = ({ meta, setMeta }) => {
    const { auth } = useAuth();

    const createSession = (reason) => {
        const now = new Date().getTime();
        const duration = Math.round((now - meta.sessionStart) / 1000) - meta.excludedTime;
        return {
            created_on: now,
            duration,
            reason,
        };
    };

    const addSessionToSubmission = (session, submission) => {
        const updatedSubmission = {
            ...submission,
            sessions: {
                ...submission.sessions,
                [auth.owner_account_id]: [...(submission.sessions?.[auth.owner_account_id] || []), session],
            },
        };
        return updatedSubmission;
    };

    useEffect(() => {
        let t1; // leave timestamp
        let t2; // return timestamp

        const handleFocus = () => {
            t2 = new Date().getTime();
            const duration = Math.round((t2 - t1) / 1000);
            setMeta((current) => ({ ...current, excludedTime: (current.excludedTime || 0) + duration }));
        };

        const handleBlur = () => {
            t1 = new Date().getTime();
        };

        window.addEventListener('focus', handleFocus);
        window.addEventListener('blur', handleBlur);
        return () => {
            window.removeEventListener('focus', handleFocus);
            window.removeEventListener('blur', handleBlur);
        };
    }, [setMeta]);

    return {
        createSession,
        addSessionToSubmission,
    };
};

export default useElapsedTime;
